import React from 'react'
import { FormGroup, TextField, Typography } from '@mui/material'
import update from 'immutability-helper'
import { initRule } from '../../../lib/rule'
import { formUpdate } from '../../../lib/form'
import AccordionPreset from './AccordionPreset'

const name = 'big-wave'

const initPreset = {
  name,
  initPoint: 3,
  damageCorrect: 1,
  damageWrong: 1
}

const BigWave = ({ accordionExpanded, onAccordionChange, rule, setRule }) => {
  const [form, setForm] = React.useState(initPreset)
  const change = formUpdate(setForm)

  React.useEffect(() => {
    setForm((rule.preset && rule.preset.name === name) ? rule.preset : initPreset)
  }, [rule.preset])

  const submit = () => {
    const newRule = update(initRule, {
      player: {
        initPoint: { $set: form.initPoint },
        pointCorrect: { $set: 1 },
        pointWrong: { $set: form.damageWrong * (-1) },
        batsuWrong: { $set: 0 },
        winPoint: { active: { $set: false } },
        losePoint: { active: { $set: true } },
        loseBatsu: { active: { $set: false } },
        specialCorrect: {
          survival: { active: { $set: true }, value: { $set: form.damageCorrect * (-1) } }
        }
      },
      preset: { $set: form }
    })
    setRule(newRule)
  }

  return (
    <AccordionPreset name={name} label="ビッグ ウェーブ" onSubmit={submit}
                     accordionExpanded={accordionExpanded === name}
                     onAccordionChange={onAccordionChange(name)}>
      <Typography variant="body2">
        初めは初期ポイントです.
      </Typography>
      <Typography variant="body2">
        初期ポイントの状態での正解で他の人全員から正解ダメージ分のポイントが減らされます. 初期ポイント未満の状態での正解で自分に1ポイントです.
      </Typography>
      <Typography variant="body2">
        誤答で自分から誤答ダメージ分のポイントが減らされます.
      </Typography>
      <Typography variant="body2">
        0 ポイント以下で失格です.
      </Typography>
      <FormGroup row={true} className="mt-5">
        <TextField type="number" variant="standard"
                   label="初期ポイント" className="init-point"
                   inputProps={{ required: true, min: 1 }}
                   value={form.initPoint}
                   onChange={change.number(value => ({ initPoint: { $set: value } }))} />
        <TextField type="number" variant="standard"
                   label="正解ダメージ" className="damage-correct ml-10"
                   inputProps={{ required: true, min: 1 }}
                   value={form.damageCorrect}
                   onChange={change.number(value => ({ damageCorrect: { $set: value } }))} />
        <TextField type="number" variant="standard"
                   label="誤答ダメージ" className="damage-wrong ml-10"
                   inputProps={{ required: true, min: 1 }}
                   value={form.damageWrong}
                   onChange={change.number(value => ({ damageWrong: { $set: value } }))} />
      </FormGroup>
    </AccordionPreset>
  )
}

export default BigWave
